function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.84487 3.13788C8.64493 2.94741 8.3284 2.95514 8.13793 3.15508C7.94747 3.35501 7.9552 3.67154 8.15513 3.86201L12.3227 7.83168L2.5 7.83168C2.22386 7.83168 2 8.05548 2 8.33168C2 8.60781 2.22386 8.83168 2.5 8.83168L12.3229 8.83168L8.15513 12.8015C7.9552 12.992 7.94747 13.3085 8.13793 13.5084C8.3284 13.7084 8.64493 13.7161 8.84487 13.5256L13.7908 8.81448C13.9035 8.70714 13.9701 8.57021 13.9907 8.42781C13.9968 8.39668 14 8.36454 14 8.33168C14 8.29854 13.9968 8.26614 13.9906 8.23481C13.9699 8.09274 13.9033 7.95614 13.7908 7.84901L8.84487 3.13788Z",
  fill: "white"
});

var SvgNavArrRight = function SvgNavArrRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavArrRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_arr_right.9ca862a8.svg";
export { ForwardRef as ReactComponent };